// extracted by mini-css-extract-plugin
export default {"modalContainer":"BalanceModal_modalContainer__iGz6N","title":"BalanceModal_title__0tToe","tagline":"BalanceModal_tagline__XXE6T"};